
const MessageSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-amber-50/30 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-8">
          <i className="ri-double-quotes-l text-6xl text-[#007bbb]"></i>
        </div>
        
        <blockquote className="text-xl md:text-2xl lg:text-3xl font-medium text-gray-900 leading-relaxed mb-8">
          患者様一人ひとりの痛みに寄り添い、<br className="hidden md:block" />
          最適な治療を提供することで、<br className="hidden md:block" />
          健康で活動的な毎日を<br className="hidden md:block" />
          取り戻していただきたい。<br />
          それが私たちの願いです。
        </blockquote>

        <div className="mt-12">
          <p className="text-2xl font-['Zen_Kaku_Gothic_New'] text-gray-700">
            岡山 花子
          </p>
        </div>
      </div>
    </section>
  );
};

export default MessageSection;
